"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlCartesian2dCameraBinder = exports.GlCartesian2dUpdateArg = void 0;
const rc_js_util_1 = require("rc-js-util");
const core_1 = require("@visualization-tools/core");
// FIXME: slightly different category of problem with binder (in that it's transform independent), would like a garbage free version
/**
 * @public
 */
class GlCartesian2dUpdateArg {
    constructor(transforms, changeId, zIndexAbs) {
        this.transforms = transforms;
        this.changeId = changeId;
        this.zIndexAbs = zIndexAbs;
    }
}
exports.GlCartesian2dUpdateArg = GlCartesian2dUpdateArg;
/**
 * @public
 * {@inheritDoc IGlCartesian2dCameraBinder}
 */
class GlCartesian2dCameraBinder extends core_1.AGlBinder {
    constructor() {
        super(...arguments);
        this.specification = specification;
        this.binderClassificationId = Symbol(); // no category matching allowed
        this.bindings = GlCartesian2dCameraBinder.getBindings();
    }
    getBinderId() {
        return "GlCamera2d";
    }
    setBufferLayout() {
        // no attributes to set
    }
    getBufferLayout() {
        return new core_1.BufferLayout([]);
    }
    areAttributesDirty() {
        return false;
    }
    initialize(componentRenderer) {
        this.bindings.cameraWorld.initialize(componentRenderer);
        this.bindings.z.initialize(componentRenderer);
    }
    getBinderData(connector, updateArg, renderer) {
        return new GlCartesian2dUpdateArg(updateArg.drawTransforms, renderer.sharedState.frameCounter, connector.graphicsSettings.zIndexAbs);
    }
    updatePointers() {
        // no action needed
    }
    updateData(updateArg) {
        this.bindings.cameraWorld.setData(updateArg.transforms.dataToInteractiveArea, updateArg.changeId);
        this.bindings.z.setData(updateArg.zIndexAbs);
    }
    bindUniforms(componentRenderer) {
        this.bindings.cameraWorld.bind(componentRenderer);
        this.bindings.z.bind(componentRenderer);
    }
    bindAttributes() {
        // no attributes to bind
    }
    static getBindings() {
        return {
            cameraWorld: new core_1.GlMat3Uniform("u_2dCamera_dataToCanvas", new rc_js_util_1.Mat3.f32()),
            z: new core_1.GlFloatUniform("u_2dCamera_z", 0),
        };
    }
}
exports.GlCartesian2dCameraBinder = GlCartesian2dCameraBinder;
const specification = new core_1.GlProgramSpecification(core_1.GlShader.combineShaders([
    core_1.mat3MultiplyVec2Shader,
    // language=GLSL
    new core_1.GlShader(
    // @formatter:off
    `
/* === camera2d === */
uniform highp mat3 u_2dCamera_dataToCanvas;
uniform highp float u_2dCamera_z;

vec3 v_2dCamera_getClipspaceCoords2d(vec2 coords)
{
    return vec3(mat3MultiplyVec2(u_2dCamera_dataToCanvas, coords), u_2dCamera_z);
}
`),
]), core_1.emptyShader);
//# sourceMappingURL=gl-cartesian2d-camera-binder.js.map